import { gql } from 'graphql-request'

export const toggleGifLike = () => gql`
  mutation toggleGifLike($id: String!) {
    toggleGifLike(id: $id) {
      success
      reason
      likes
      hasLiked
    }
  }
`

export interface ToggleGifLikeResult {
  success: boolean
  reason?: string
  likes: number
  hasLiked: boolean
}

export const toggleGifLikeResult = (data: any): ToggleGifLikeResult => {
  return data.toggleGifLike as ToggleGifLikeResult
}
